export default "__VITE_ASSET__w1lA_Xx5__"